// GA4(dataLayer) と PostHog の両方へ送るドメインイベントの集約。
// GA4のみのイベントは ga.ts、両方へ送るイベントはこのファイル、と置き場所で送信先を示す。
// プロパティを持たないクリック（認証3択など）は PostHog Autocapture に任せ、ここには置かない。

import type { ExploreModeType } from '@/constants';
import { trackDualEvent } from '@/utils/trackDualEvent';
import { EVENT_NAMES } from '@monorepo/common';

// 素材を選ぶ - コマクリック。
export const sendMaterialClickEvent = (params: {
  materialId: number;
  materialName: string;
  workId: number;
  workName: string;
  userId: number;
}) => {
  trackDualEvent(EVENT_NAMES.materialClick, {
    materialId: params.materialId,
    materialName: params.materialName,
    workId: params.workId,
    workName: params.workName,
    user_id: params.userId,
  });
};

// TOP - ピックアップバナークリック（position は掲載枠の並び順・0始まり）
export const sendPickupBannerClickEvent = (params: { bannerId: number; position: number; userId: number }) => {
  trackDualEvent(EVENT_NAMES.pickupBannerClick, {
    bannerId: params.bannerId,
    position: params.position,
    user_id: params.userId,
  });
};

// TOP - 探索導線（ヒーローCTA）クリック。exploreMode で入口を区別する
export const sendExploreEntryClickEvent = (params: { exploreMode: ExploreModeType; userId: number }) => {
  trackDualEvent(EVENT_NAMES.exploreEntryClick, {
    exploreMode: params.exploreMode,
    user_id: params.userId,
  });
};
